export const TRANSLATIONS_FR_HOME_QUEUE_AND_ACTIVITY = {
  "home.actionItems.eyebrow": "Actions en attente",
  "home.actionItems.title": "Actions recommandées",
  "home.actionItems.connection": "Suggestions pour garder la file à jour.",
  "home.actionItems.empty": "Aucune action en attente.",
  "home.actionItems.unknownDocument": "Document inconnu",
  "home.actionItems.due": "Échéance",
  "home.smartQueue.eyebrow": "Éléments prioritaires",
  "home.smartQueue.title": "Documents qui nécessitent votre revue",
  "home.smartQueue.totalLabel": "en attente",
  "home.smartQueue.description": "Priorisation selon le risque, le responsable et l'état de chaque document.",
  "home.smartQueue.connection": "Alimentée par les dates critiques et les dernières classifications.",
  "home.smartQueue.metricsTitle": "Métriques opérationnelles (optionnel)",
  "home.smartQueue.previewTitle": "Les plus prioritaires",
  "home.smartQueue.previewSubtitle": "Top 5",
  "home.smartQueue.previewAction": "Voir",
  "home.smartQueue.previewFilterRole": "Filtrer par rôle",
  "home.smartQueue.previewViewAll": "Voir tout",
  "home.smartQueue.status.needsReview": "Nécessitent votre revue",
  "home.smartQueue.status.processing": "En traitement automatisé",
  "home.smartQueue.status.ready": "Prêts à publier",
  "home.smartQueue.statusHelper.needsReview": "Validation humaine requise avant d'avancer.",
  "home.smartQueue.statusHelper.processing": "L'IA poursuit l'extraction et la classification.",
  "home.smartQueue.statusHelper.ready": "Peuvent passer en publication ou en consultation.",
  "home.smartQueue.cta": "Voir les priorités",
  "home.smartQueue.tooltip": "Ouvrir le détail de tous les documents priorisés.",
  "home.smartQueue.clearFilter": "Effacer le filtre par statut",
  "home.smartQueue.panelEyebrow": "Détail de priorisation",
  "home.smartQueue.panelTitle": "Documents regroupés par l'assistant",
  "home.smartQueue.panelSubtitle": "Segmentés par statut d'automatisation et rôle déclencheur.",
  "home.smartQueue.closePanel": "Fermer le panneau des priorités",
  "home.smartQueue.badgeRole": "Déclenché par rôle",
  "home.smartQueue.badgeDate": "Déclenché par date",
  "home.smartQueue.filterActive": "Filtre appliqué par rôle ou statut.",
  "home.smartQueue.actions.snooze": "Reporter 24h",
  "home.smartQueue.actions.done": "Marquer terminé",
  "home.smartQueue.actions.assign": "Me l'attribuer",  "home.smartQueue.markAsDone": "Marquer comme Terminé",
  "home.smartQueue.snooze": "Reporter",
  "home.smartQueue.recommendedAction": "Action Recommandée",  "home.smartQueue.mutation.snoozeSuccess": "Élément reporté de 24h.",
  "home.smartQueue.mutation.doneSuccess": "Élément marqué comme terminé.",
  "home.smartQueue.mutation.assignSuccess": "Élément attribué à vous.",  "home.smartQueue.mutation.reclassifySuccess": "Document reclassifié avec succès.",
  "home.smartQueue.reclassifyTooltip": "Ré-analyser avec l'IA",
  "home.smartQueue.reclassifyModal.title": "Reclassifier le Document",
  "home.smartQueue.reclassifyModal.reasonLabel": "Raison (requise)",
  "home.smartQueue.reclassifyModal.reasonPlaceholder": "Ex: Document incorrectement classifié comme contrat",
  "home.smartQueue.reclassifyModal.correctedTypeLabel": "Type de classification correct (requis)",
  "home.smartQueue.reclassifyModal.correctedTypePlaceholder": "Sélectionnez le type correct...",
  "home.smartQueue.reclassifyModal.originalTypeHint": "Type actuel",
  "home.smartQueue.reclassifyModal.notesLabel": "Notes supplémentaires (optionnel)",
  "home.smartQueue.reclassifyModal.notesPlaceholder": "Informations supplémentaires sur la reclassification...",
  "home.smartQueue.reclassifyModal.confirm": "Reclassifier",
  "home.smartQueue.reclassifyModal.cancel": "Annuler",
  "home.smartQueue.reviewDocument": "Examiner le document",
  "home.smartQueue.openDocument": "Ouvrir le document",
  "home.smartQueue.executeAction": "Exécuter l'action",
  "home.smartQueue.mutation.actionSuccess": "Action exécutée avec succès.",  "home.smartQueue.panelEmpty": "Aucun document en attente.",
  "home.smartQueue.empty": "Aucun élément en attente. Vous êtes à jour.",
  "home.nextAction.eyebrow": "Prochaine étape recommandée",
  "home.nextAction.title": "Prochaine action",
  "home.nextAction.connection": "Basé sur ce qui a été détecté aujourd'hui.",
  "home.nextAction.reason.pending_review": "Des documents attendent votre approbation.",
  "home.nextAction.reason.new_documents": "De nouveaux documents sont prêts à être ingérés.",
  "home.nextAction.reason.ready_to_query": "Tout est prêt pour interroger l'assistant.",
  "home.nextAction.reason.due_soon": "Une échéance approche.",
  "home.nextAction.reason.overdue": "Un document est en retard.",
  "home.nextAction.reason.high_priority": "Un document prioritaire demande attention.",
  "home.nextAction.reason.compliance_required": "Une action de conformité est requise.",
  "home.nextAction.tooltipLabel": "Pourquoi cette recommandation",
  "home.nextAction.tooltip.queue": "Générée à partir des dates détectées et de vos priorités.",
  "home.nextAction.ack": "Reconnaître",
  "home.nextAction.cta": "Voir",
  "home.nextAction.openDocument": "Ouvrir le document",
  "home.nextAction.ackSuccess": "Action confirmée.",
  "home.nextAction.empty": "Tout est clair. Rien ne requiert votre attention pour l'instant.",
  "home.nextAction.action.review": "Revoir",
  "home.nextAction.action.upload": "Téléverser",
  "home.nextAction.action.chat": "Discuter",
  "home.nextAction.reason.needs_review": "Des documents nécessitent votre approbation.",
  "home.lastActivity.eyebrow": "Activité pertinente",
  "home.lastActivity.title": "Changements récents dans les décisions",
  "home.lastActivity.connection": "Nous affichons uniquement les changements qui affectent une décision ou aident à l'expliquer.",
  "home.lastActivity.previewTitle": "Ce qui a changé",
  "home.lastActivity.previewSubtitle": "plus récent",
  "home.lastActivity.previewAction": "Revoir",
  "home.lastActivity.markAllRead": "Tout marquer comme lu",
  "home.lastActivity.type.classification": "Classification",
  "home.lastActivity.type.ingestion": "Ingestion",
  "home.lastActivity.type.extraction": "Extraction",
  "home.lastActivity.type.normalization": "Normalisation",
  "home.lastActivity.type.validation": "Validation",
  "home.lastActivity.tooltip": "Cliquez pour voir l'impact sur les priorités.",
  "home.lastActivity.documentsImpacted": "Documents liés",
  "home.lastActivity.queueImpacted": "Impact sur la décision",
  "home.lastActivity.navigateQueue": "Voir les éléments impactés",
  "home.lastActivity.historyLink": "Voir l'historique",
  "home.lastActivity.historyEyebrow": "Journal pertinent",
  "home.lastActivity.historyTitle": "Historique d'activité",
  "home.lastActivity.closeHistory": "Fermer l'historique",
  "home.lastActivity.openPanel": "Voir l'activité pertinente",
  "home.lastActivity.closePanel": "Fermer l'activité pertinente",
  "home.lastActivity.historyEmpty": "Aucun événement à afficher.",
  "home.lastActivity.empty": "Aucune activité récente.",
  "home.lastActivity.supportSignal": "Signal de support",
  "home.lastActivity.event.decisionUpdated": "Décision mise à jour",
  "home.lastActivity.event.missingInformationDetected": "Information manquante détectée",
  "home.lastActivity.event.priorityRecalculated": "Priorité recalculée",
  "home.lastActivity.event.evidenceAdded": "Preuve ajoutée",
  "home.lastActivity.event.stateChanged": "État modifié",
  "home.lastActivity.event.actionExecuted": "Action exécutée",
  "home.lastActivity.event.supportSignal": "Mise à jour de support",
  "home.lastActivity.event.decisionUpdatedCopy": "La décision a changé récemment et mérite une vérification rapide.",
  "home.lastActivity.event.missingInformationDetectedCopy": "Une donnée manquante a été détectée et peut bloquer la prochaine action.",
  "home.lastActivity.event.priorityRecalculatedCopy": "La priorité a changé et peut nécessiter une revue plus rapide.",
  "home.lastActivity.event.evidenceAddedCopy": "Une nouvelle preuve est arrivée et la recommandation a été réévaluée.",
  "home.lastActivity.event.stateChangedCopy": "La décision a changé d'état après une validation récente.",
  "home.lastActivity.event.actionExecutedCopy": "L'action a été enregistrée et la décision devrait refléter un nouvel état.",
  "home.lastActivity.event.supportSignalCopy": "Un signal de support a été enregistré sans modifier directement une décision visible.",
  "home.nextBestDecision.eyebrow": "Décision principale",
  "home.nextBestDecision.title": "Meilleure décision suivante",
  "home.nextBestDecision.viewDecision": "Voir le détail",
  "home.nextBestDecision.owner": "Responsable",
  "home.nextBestDecision.dueAt": "Échéance",
  "home.nextBestDecision.nextAction": "Action suivante",
  "home.nextBestDecision.priority": "Priorité",
  "home.nextBestDecision.priorityUnspecified": "Sans niveau",
  "home.nextBestDecision.risk": "Risque",
  "home.nextBestDecision.notAvailable": "Sans donnée",
  "home.nextBestDecision.confidence": "Confiance",
  "home.nextBestDecision.functionalStatus": "Action recommandée",
  "home.nextBestDecision.recommendationCopy": "Home IA met en avant la meilleure recommandation métier pour ce cas. Utilisez les actions opérationnelles du détail pour attribuer, reporter, terminer, écarter ou réévaluer.",
  "home.entityActions.toggle": "Actions de l'entité",
  "home.entityActions.questionsTitle": "Questions suggérées",
  "home.entityActions.questionsError": "Impossible de charger les questions.",
  "home.entityActions.questionsEmpty": "Aucune question suggérée pour cette entité.",
  "home.entityActions.askAboutEntity": "Poser une question sur cette entité",
  "home.entityActions.askPrefill": "Parlez-moi de",
  "home.entityActions.generate": "Générer un document",
  "home.entityActions.sourcesTitle": "Ces sources seront utilisées",
  "home.entityActions.sourcesError": "Impossible de charger les sources.",
  "home.entityActions.sourcesEmpty": "Aucune source visible pour générer.",
  "home.entityActions.sourcesConfirm": "Générer avec ces sources",
  "home.entityActions.cancel": "Annuler",
  "home.entityActions.version": "version",
  "home.recentChanges.title": "Modifications récentes",
  "home.recentChanges.viewAll": "Tout voir",
  "home.recentChanges.empty": "Aucune modification récente pertinente dans vos documents.",
  "home.recentChanges.errorTitle": "Impossible de charger les modifications",
  "home.recentChanges.errorMessage": "Réessayez dans quelques secondes.",
  "home.nextBestDecision.urgency.critical": "Urgence élevée",
  "home.nextBestDecision.urgency.high": "Agir bientôt",
  "home.nextBestDecision.urgency.medium": "Surveiller de près",
  "home.nextBestDecision.urgency.low": "Urgence faible",
  "home.nextBestDecision.allClear.title": "Tout est à jour",
  "home.nextBestDecision.allClear.subtitle": "Aucune décision ne requiert votre attention pour le moment. Profitez-en pour anticiper la suite.",
  "home.nextBestDecision.allClear.navLabel": "Accès rapides",
  "home.nextBestDecision.allClear.reviewExpirations": "Vérifier les échéances",
  "home.nextBestDecision.allClear.viewChanges": "Voir les changements récents",
  "home.nextBestDecision.allClear.viewAlerts": "Voir les alertes",
};
